import * as z from "zod";
import { documentStatuses } from "./enums";

// What another domain shows of a document it asked for (ADR-230), in a file of its own: sales, procurement, logistics
// and claims embed it, and take nothing else of documents (ADR-271).

/**
 * The credit note of what a domain approved (ADR-230), as that domain shows it: the document documents asked Business
 * Central for, its state and the number BC gave it. Null until documents asked for it.
 */
export const creditNoteDocumentDto = z
  .object({ documentId: z.uuid(), status: z.enum(documentStatuses), documentNo: z.string().nullable() })
  .meta({ id: "CreditNoteDocument" });
export type CreditNoteDocumentDto = z.output<typeof creditNoteDocumentDto>;
